import {mapState} from "vuex";

export default {
  name: "Licenses",
  created() {
    this.$store.dispatch('Legal/get_licenses');
  },
  computed: {
    ...mapState({
      status: state => state.Legal.status,
      licenses: state => state.Legal.licenses,
    })
  },
}